import { render, staticRenderFns } from "./Preparadas.vue?vue&type=template&id=55db12a0"
import script from "./Preparadas.vue?vue&type=script&lang=js"
export * from "./Preparadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports